class FixedBarUpper extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.selectors = {
      addToCartButtonContainer: '[data-product-add-to-cart-button-container]',
      stickyAddToCart: '[data-product-sticky-add-to-cart]',
    }
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    window.addEventListener('load', () => {
      this.detectAddToCartElement()
    })

    this.listeners.add(this, 'click', this.scrollToButton)
  }

  scrollToButton () {
    const addToCartButtonContainer = document.querySelector(
      this.selectors.addToCartButtonContainer,
    )

    if (addToCartButtonContainer) {
      addToCartButtonContainer.scrollIntoView({
        behavior: 'smooth', // Smooth scrolling
        block: 'center', // Scroll element to the center of the screen
        inline: 'center', // Optionally, center it horizontally as well if needed
      })
    }
  }

  detectAddToCartElement () {
    const addToCartButtonContainer = document.querySelector(
      this.selectors.addToCartButtonContainer,
    )
    const stickyAddToCart = document.querySelector(
      this.selectors.stickyAddToCart,
    )

    if (!addToCartButtonContainer || !stickyAddToCart) {
      console.error('Required elements are not available in the DOM.')
      return
    }

    let isScrollingDown = false
    let lastScrollTop = 0

    // Scroll event listener to track scroll direction
    window.addEventListener('scroll', () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop
      isScrollingDown = scrollTop > lastScrollTop
      lastScrollTop = scrollTop
    })

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            stickyAddToCart.classList.add('prd-Detail_StickyAddToCart-hide')
          } else {
            if (isScrollingDown) {
              stickyAddToCart.classList.add('prd-Detail_StickyAddToCart-hide')
            } else {
              stickyAddToCart.classList.remove(
                'prd-Detail_StickyAddToCart-hide',
              )
            }
          }
        })
      },
      {
        root: null,
        rootMargin: '50px',
        threshold: 0,
      },
    )

    // Observe the add to cart button container
    observer.observe(addToCartButtonContainer)
  }
}

if (!customElements.get('fixed-bar-upper')) {
  customElements.define('fixed-bar-upper', FixedBarUpper)
}
